import React from 'react';
import AddFormModal from './AddFormModal'
import AddFormModal3 from './v3/AddFormModal'
import EdiTable from './EdiTable.jsx'
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import {AREA} from './../../index'


export default class Resource extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: {
                data: [],
                metadata: []
            },
            userfilter: props.data.userfilter ? props.data.userfilter : [],
            metadata: props.data.metadata,
            url: props.data.url,
            params: props.data.params ? props.data.params : {},
            filter: props.data.filter ? props.data.filter : {}
        }
    }
    componentDidMount(){
        this.setState({
            loading: true
        })
        this.loadFromServer();
    }
    loadFromServer() {
        const filter = this.state.filter;
        const params = this.state.params;
        params.filter = [];        
        if (filter !== undefined) {
            params.filter = filter;
        }
        this.props.childProps.dataProvider.getList(this.state.url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    this.setState({
                        loading: false,
                        data: response.data
                    })
                } else {
                    toast.error("Something went wrong... backend not reachable. Try to reload page", {})
                }
            }
        ).catch(error => {
            toast.error("Something went wrong... backend returned error", {})
        });
    }
    onRowAdded(data) {
        var newdata = this.state.data;
        newdata.data.push(data);
        this.setState({data: newdata});
    }
    onFilter(filter) {
        this.setState({
                loading: true,
                offset: 0,
                filter:  filter.toJS()
            }, function () {
                this.loadFromServer()
            }
        );
    }
    render() {
        let {addButtonText, disableAdd, addButtonType, addButtonLink} =  this.props;
        addButtonText =  addButtonText ? addButtonText : "Add";
        let addResource = <AddFormModal
            bsStyle="outline-primary"
            addButton="true"
            addButtonValue={addButtonText}
            metadata={this.state.metadata}
            url={this.state.url}
            remotemeta={this.state.data.metadata}
            onRowAdded={this.onRowAdded.bind(this)}
            {...this.props}
        />

        if (AREA === "admin") {
            addResource = <AddFormModal3
                bsStyle="primary"
                addButton="true"
                addButtonValue={addButtonText}
                metadata={this.state.metadata}
                url={this.state.url}
                remotemeta={this.state.data.metadata}
                onRowAdded={this.onRowAdded.bind(this)}
                {...this.props}
            />
        }

        if (addButtonType === "link") {
            addResource = <Link to={addButtonLink} className="btn btn-outline-primary">{addButtonText}</Link>
        }

        return(
            <div className="row">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    closeOnClick={true}
                    pauseOnHover={true}
                    draggable={true}
                    progress="undefined"
                />
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            { disableAdd ||
                            addResource}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <EdiTable
                                data={this.state.data}
                                metadata={this.state.metadata}
                                url={this.state.url}
                                childProps={this.props.childProps}
                                pagination = {this.props.pagination}
                                userfilter = {this.state.userfilter}
                                onFilter = { this.onFilter.bind(this) }
                                loading = {this.state.loading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
